/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ style: NonNullable<unknown> }} Caption_Style_UpdatedInputs */

const en_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caption style updated to ${i?.style}`)
};

const fr_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Style de sous-titrage mis à jour : ${i?.style}`)
};

const de_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenstil auf ${i?.style} aktualisiert`)
};

const it_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stile didascalia aggiornato a ${i?.style}`)
};

const ru_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Стиль подписи обновлен до ${i?.style}`)
};

const es_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estilo de subtítulo actualizado a ${i?.style}`)
};

const zh_cn2_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`标题样式已更新为${i?.style}`)
};

const ja_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`キャプションのスタイルが ${i?.style} に更新されました`)
};

const hi_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली को ${i?.style} में अपडेट किया गया`)
};

const pt_pt2_caption_style_updated = /** @type {(inputs: Caption_Style_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estilo da legenda atualizado para ${i?.style}`)
};

/**
* | output |
* | --- |
* | "Caption style updated to {style}" |
*
* @param {Caption_Style_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_updated = /** @type {((inputs: Caption_Style_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style_updated(inputs)
	if (locale === "de") return de_caption_style_updated(inputs)
	if (locale === "it") return it_caption_style_updated(inputs)
	if (locale === "ru") return ru_caption_style_updated(inputs)
	if (locale === "es") return es_caption_style_updated(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style_updated(inputs)
	if (locale === "ja") return ja_caption_style_updated(inputs)
	if (locale === "hi") return hi_caption_style_updated(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style_updated(inputs)
	return en_caption_style_updated(inputs)
});